import MergeCompaniesDisplayContainer from "@/components/MergeCompanies/mergeCompaniesDisplayContainer.component";
import MergeCompaniesSelection from "@/components/MergeCompanies/mergeCompaniesSelection.component";
import MergeCompaniesSubmitConfirmationDialog from "@/components/MergeCompanies/mergeCompaniesSubmitConfirmationDialog.component";
import MergeCompaniesUserSelection from "@/components/MergeCompanies/mergeCompaniesUserSelection.component";
import { ROUTE_USER_MANAGEMENT } from "@/constants/routes.constants";
import { MergeCompaniesContext } from "@/services/MergeCompaniesContext/mergeCompaniesContext";
import { Button } from "@/shadcn/components/ui/button";
import { Card, CardContent } from "@/shadcn/components/ui/card";
import React, { useContext } from "react";
import { useNavigate } from "react-router";

type MergeCompaniesMainProps = {
  // TODO: add props here
};

const MergeCompaniesMain: React.FC<MergeCompaniesMainProps> = (props) => {
  const { keepSideUser, removeSideUser, successfulSubmission, resetStates } =
    useContext(MergeCompaniesContext);
  const nav = useNavigate();
  return successfulSubmission ? (
    <div className="mt-2">
      <div className="text-center text-2xl font-bold">
        Companies merged successfully!
      </div>

      <div className="mt-8 flex items-center justify-center gap-4 text-center">
        <Button
          onClick={() => {
            nav(ROUTE_USER_MANAGEMENT);
          }}
        >
          View Users
        </Button>
        <Button onClick={resetStates}>Merge More Companies</Button>
      </div>
    </div>
  ) : (
    <div className="grid w-full grid-cols-1 gap-4 p-4 lg:grid-cols-2">
      <Card>
        <CardContent>
          <div className="text-center text-2xl font-bold">Keep Details</div>
          <div>
            <div className="mt-4 mb-1 text-center">Select User</div>
            <MergeCompaniesUserSelection side="keep" />
          </div>
          {keepSideUser && (
            <div>
              <div className="mt-4 mb-1 text-center">Select Company</div>
              <MergeCompaniesSelection side="keep" />
            </div>
          )}
          <div className="mt-8">
            <MergeCompaniesDisplayContainer side="keep" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <div className="text-center text-2xl font-bold">Remove Details</div>
          <div>
            <div className="mt-4 mb-1 text-center">Select User</div>
            <MergeCompaniesUserSelection side="remove" />
          </div>
          {removeSideUser && (
            <div>
              <div className="mt-4 mb-1 text-center">Select Company</div>
              <MergeCompaniesSelection side="remove" />
            </div>
          )}
          <div className="mt-8">
            <MergeCompaniesDisplayContainer side="remove" />
          </div>
        </CardContent>
      </Card>
      {/* span both cols */}
      <div className="col-span-1 text-center lg:col-span-2">
        <MergeCompaniesSubmitConfirmationDialog />
      </div>
    </div>
  );
};

export default MergeCompaniesMain;
